import React from 'react';
import { LayersContainerContext } from './utils';
import { useEagerLoadTreeNodes } from './hooks';

export const LayersContainerContextProvider = ({ children }) => {
  const { treeControlState, setTreeControlState } = useEagerLoadTreeNodes();

  return (
    <LayersContainerContext.Provider value={{ treeControlState, setTreeControlState }}>
      {children}
    </LayersContainerContext.Provider>
  );
};
